import React from 'react'
import baseComponents from 'gatsby-theme-docz/src/components'
import {Styled} from "theme-ui"

export default {
    ...baseComponents,
    th: ({align, ...props}) => (
        <Styled.th style={align && {textAlign: align}} {...props} />
    ),
    td: ({align, ...props}) => (
        <Styled.td style={align && {textAlign: align}} {...props} />
    )
}